/**
 * USB/HID product identifiers paired with MULTILASER_STEELPLAY_VENDOR_ID from vendorIds.ts.
 * Grouped by vendor ID, including accessories that share it.
 * @module
 * @internal
 */

/**
 * Product identifier (PID) of the Multilaser Warrior Joypad (JS083).
 * Pair with MULTILASER_STEELPLAY_VENDOR_ID, also used by the Steelplay entry.
 */
export const MULTILASER_WARRIOR_JOYPAD_PRODUCT_ID = 0x57AB

/**
 * Product identifier (PID) of the Steelplay Metaltech P4 controller.
 * Pair with MULTILASER_STEELPLAY_VENDOR_ID, also used by the Multilaser entry.
 */
export const STEELPLAY_METALTECH_P4_PRODUCT_ID = 0x0E16
